module.exports = __webpack_public_path__ + "static/img/Stu2@2x.9f29031d.png";